import styled from "@emotion/styled";

const PieChartContainer = styled.div`
  width: 100%;
  height: 300px;
`;

export { PieChartContainer };
